import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;

  h1 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 800;
    color: ${(p) => p.theme.textPrimary};
  }

  p {
    margin: 0.25rem 0 0;
    font-size: 0.9rem;
    color: ${(p) => p.theme.textMuted};
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <Wrap>
    <div>
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </div>
    {actions && <Actions>{actions}</Actions>}
  </Wrap>
);

export default PageHeader;
